'use strict';

cartErrorMessage.$inject = ["common", "CartMessageTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartErrorMessage = cartErrorMessage;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartErrorMessage(common, CartMessageTypes) {
    var clazz = function CartErrorMessage() {
        var defaults = {
            id: 0,
            message: '',
            type: 0, // 0 = info, 1 = warning, 2 = disabled, 3 = blocking
            isMessageActive: false,
            canDisableMessage: false,
            isProductDisabled: false

            // when disabled, product is shown, cart can be ordered
            // when blocking, cart cannot be ordered
            // canDisable => show 'deactivate message' button
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.message = resource.message;
        o.type = common.serverTypes.getClientValue(CartMessageTypes, resource.type);
        if (o.type === 'disabled') {
            o.type = 'error';
        }
        o.isMessageActive = !!resource.active;
        o.canDisableMessage = !!resource.canDisable;
        o.isProductDisabled = resource.type === 2;
        o.code = resource.code;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.message = resource.message;
        o.type = resource.type;
        o.isMessageActive = resource.isMessageActive;
        o.canDisableMessage = resource.canDisableMessage;
        o.isProductDisabled = resource.isProductDisabled;
        o.code = resource.code;
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartErrorMessageModel.js
// module id = 732
// module chunks = 0